module.exports = class AssertionCodebook {
	agent = null;
	subject = null;
	assertionDate = null;
	expirationDate = null;
	decayFunction = null;
	negative = null;
	evidence = null;
	assertionShortId = null;
};
